import styled from 'styled-components';

export const Paragraph = styled('p')`
  font-size: 1.6rem;
`;
